import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  getSpacingStyles,
  getBorderStyles,
} from 'components_library/utils/getStyleObject';
import s from './GridMaker.scss';

const GridMaker = props => {
  const { layout, spacingClasses, isMobile, extraProps = {} } = props;

  if (!(Array.isArray(layout) && layout.length > 0)) return null;

  let renderedComponentIndex = -1;

  const makeColumn = (columnObj = {}, colIndex, rowIndex) => {
    const { componentMap, components } = props;
    const { span, spacing, border } = columnObj;

    if (!span) return null;
    renderedComponentIndex += 1;

    const spacingColClasses = getSpacingStyles(spacing, isMobile, 'column');
    const borderColClasses = getBorderStyles(border, 'column');

    const columnClasses = classNames({
      [`col_l_${span || '12'}`]: true,
    });

    const ColumnComponent =
      components[renderedComponentIndex] &&
      components[renderedComponentIndex].type &&
      componentMap &&
      typeof componentMap[components[renderedComponentIndex].type] ===
        'function'
        ? componentMap[components[renderedComponentIndex].type](
            components[renderedComponentIndex],
            props.level + 1,
            isMobile,
            props.items,
            props.ga,
            spacingClasses,
            props.SectionWrapperComponent,
            props.SliderComponent,
            extraProps,
          )
        : null;
    if (!ColumnComponent) {
      return null;
    }

    return (
      <div
        className={`${columnClasses} ${spacingColClasses} ${borderColClasses}`}
        key={`grid-col-${rowIndex}`}
      >
        {ColumnComponent}
      </div>
    );
  };

  const makeRow = (row, index) => {
    if (!(Array.isArray(row) && row.length > 0)) return null;

    return (
      <div className={`row ${spacingClasses}`} key={`grid-row-${index}`}>
        {row.map((column, colIndex) =>
          makeColumn(column, colIndex, index, row.length),
        )}
      </div>
    );
  };

  return (
    <div className={`${s.grid} ${props.className}`}>
      {layout.map((columns, index) => makeRow(columns, index))}
    </div>
  );
};

GridMaker.propTypes = {
  layout: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({}))).isRequired,
  styles: PropTypes.shape({}),
  components: PropTypes.shape({}),
  componentMap: PropTypes.shape({}),
  isMobile: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape({})),
  ga: PropTypes.shape({}),
  extraProps: PropTypes.shape({}),
  className: PropTypes.string,
  level: PropTypes.number,
  SectionWrapperComponent: PropTypes.func,
  SliderComponent: PropTypes.func,
};

GridMaker.defaultProps = {
  styles: undefined,
  components: [],
  componentMap: {},
  isMobile: false,
  items: [],
  ga: undefined,
  extraProps: {},
  className: '',
  level: 0,
  SectionWrapperComponent: undefined,
  SliderComponent: undefined,
};

export default GridMaker;
